import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';
import Reveal from 'react-reveal/Reveal';
import CalendarItem from '../CalendarItem';
import {
  CalendarMonth as CalendarMonthProps,
} from '../../core/typings/api';
import './styles.scss';

const CalendarMonth = ({
  items,
  monthName,
}: CalendarMonthProps) => (
  <div className="calendar-month">
    <div className="calendar-month__month-name">
      {monthName}
    </div>
    {items && (
      <div className="calendar-month__days">
        {items.map((day) => (
          <div key={uuidv4()} className="calendar-month__day-item">
            <div className="calendar-month__day-date">
              {day.day}
            </div>
            <div className="calendar-month__day-events">
              {day.items.map((event, index) => (
                <Reveal effect="shortFadeInUp" delay={index * 20}>
                  <CalendarItem {...event} />
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default CalendarMonth;
